export const LIST_PAGE_ROUTE = '?page=1';
